/**
 * Eclipse Cubiertas - Frontend Tracker (analítica anti-adblocker)
 *
 * - visitor_id persistido en localStorage (uuid v4)
 * - session_id persistido en sessionStorage (uuid v4)
 * - UTMs capturados al inicio de la sesión y persistidos
 * - trackEvent usa navigator.sendBeacon con fallback a fetch keepalive
 * - try/catch silencioso: NUNCA debe romper la UI
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function uuid4() {
    if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
}

export function getVisitorId() {
    try {
        let v = localStorage.getItem("eclipse_visitor_id");
        if (!v) {
            v = uuid4();
            localStorage.setItem("eclipse_visitor_id", v);
        }
        return v;
    } catch {
        return null;
    }
}

export function getSessionId() {
    try {
        let s = sessionStorage.getItem("eclipse_session_id");
        if (!s) {
            s = uuid4();
            sessionStorage.setItem("eclipse_session_id", s);
        }
        return s;
    } catch {
        return null;
    }
}

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function captureAndPersistUtms() {
    try {
        const sp = new URLSearchParams(window.location.search);
        const present = {};
        let any = false;
        UTM_KEYS.forEach((k) => {
            const v = sp.get(k);
            if (v) {
                present[k] = v;
                any = true;
            }
        });
        if (any) {
            sessionStorage.setItem("eclipse_utms", JSON.stringify(present));
        }
        if (document.referrer && !sessionStorage.getItem("eclipse_referrer")) {
            sessionStorage.setItem("eclipse_referrer", document.referrer);
        }
    } catch {
        /* noop */
    }
}

export function getUtms() {
    try {
        const raw = sessionStorage.getItem("eclipse_utms");
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
}

function getReferrer() {
    try {
        return sessionStorage.getItem("eclipse_referrer") || document.referrer || null;
    } catch {
        return null;
    }
}

function inferSitio(path) {
    if (!path) path = window.location.pathname;
    if (path.startsWith("/flexshade")) return "flexshade";
    if (path.startsWith("/velarias")) return "velarias";
    return "eclipse";
}

export function trackEvent(event_type, props = {}) {
    try {
        if (!BACKEND_URL) return;
        const utms = getUtms();
        const payload = {
            event_type,
            visitor_id: getVisitorId(),
            session_id: getSessionId(),
            path: window.location.pathname,
            sitio: props.sitio || inferSitio(),
            referrer: getReferrer(),
            ...utms,
            props,
        };
        const url = `${BACKEND_URL}/api/events`;
        const data = JSON.stringify(payload);
        if (navigator.sendBeacon) {
            const blob = new Blob([data], { type: "application/json" });
            const ok = navigator.sendBeacon(url, blob);
            if (ok) return;
        }
        fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: data,
            keepalive: true,
        }).catch(() => {
            /* swallow */
        });
    } catch {
        /* swallow — never break UI */
    }
}

let _last_pageview_path = null;
export function trackPageView() {
    const p = window.location.pathname;
    if (_last_pageview_path === p) return;
    _last_pageview_path = p;
    trackEvent("page_view");
}

let _form_open_fired = false;
export function trackFormOpenOnce(source) {
    if (_form_open_fired) return;
    _form_open_fired = true;
    trackEvent("form_open", { source });
}

export function trackWhatsappClick(source) {
    trackEvent("whatsapp_click", { source });
}

export function trackPhoneClick(source) {
    trackEvent("phone_click", { source });
}

export function trackCtaClick(label, location) {
    trackEvent("cta_click", { label, location });
}
